import { db } from "services/firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { User as FirebaseUser } from "firebase/auth";

import { USER_COLLECTION } from 'config';

export const addCustomerIdToUser = async (stripeCustomerId: string, currentUser: FirebaseUser | null | undefined) => {
    await updateDoc(doc(db, USER_COLLECTION, currentUser!.uid), {
        stripe_customer_id: stripeCustomerId,
    });
}

export const doesUserHaveCustomerId = async (currentUser: FirebaseUser | null | undefined) => {
    const userDoc = await getDoc(doc(db, USER_COLLECTION, currentUser!.uid));
    const customerId = userDoc.data()!.stripe_customer_id

    return {hasCustomerId: !!customerId, customerId };
}